/* Desktop gallery (Oct 1 2026): clicking a thumbnail moves that photo into the large slot instead of
   opening the lightbox; the large photo still opens the lightbox. Capture phase, so it runs before
   the product section's own lightbox listener. */
(function () {
  document.addEventListener('click', function (e) {
    if (!window.matchMedia('(min-width: 991px)').matches) return;
    var img = e.target.closest && e.target.closest('[data-tmp-gallery] img');
    if (!img) return;
    var g = img.parentNode;
    var main = g.querySelector('img.is-main') || g.querySelector('img');
    if (img === main) return;
    e.preventDefault(); e.stopPropagation();
    if (main) main.classList.remove('is-main');
    img.classList.add('is-main');
    var src = img.getAttribute('src');
    if (src) img.setAttribute('src', src.replace(/([?&])width=\d+/, '$1width=1200'));
  }, true);
})();

/* Fabric composition + sold-out sizes (Oct 1 2026).
   - The fabric composition lives in the Features tab and follows the chosen fabric.
   - Sold-out sizes: the load-time tmp__opt--soldout class was never cleared when the shopper switched
     fabric or colour; the section keeps the live state in is-oos, so the stale class is removed. */
(function () {
  var COMP = {
    'cozy fleece': '90% polyester / 10% cotton, glass bead fill',
    'plush minky': '100% polyester, glass bead fill'
  };
  var target = null;
  function featuresPanel() {
    var btns = document.querySelectorAll('.tmp__tabbtn');
    for (var i = 0; i < btns.length; i++) {
      if (/features/i.test(btns[i].textContent)) {
        return document.querySelector('.tmp__tabpanel[data-panel="' + btns[i].getAttribute('data-tab') + '"]');
      }
    }
    return null;
  }
  function move() {
    var li = document.querySelector('.tmp__specs [data-tmp-fabric-comp]');
    if (!li) return;
    var panel = featuresPanel();
    if (!panel) return;
    var text = li.textContent.replace(/^\s*fabric\s*/i, '').trim();
    var ul = li.parentNode;
    li.remove();
    if (ul && !ul.children.length) ul.remove();
    target = document.createElement('p');
    target.className = 'tmp__fabric-comp';
    target.style.marginTop = '8px';
    panel.appendChild(target);
    set(text);
  }
  function set(text) { if (target && text) target.innerHTML = '<b>Fabric:</b> ' + text; }
  function sync() {
    document.querySelectorAll('.tmp__opt--soldout').forEach(function (b) { b.classList.remove('tmp__opt--soldout'); });
    var active = document.querySelector('.tmp__fabric.is-active .tmp__fabric-name');
    if (active) set(COMP[active.textContent.trim().toLowerCase()]);
  }
  function init() { move(); var a = document.querySelector('.tmp__fabric.is-active .tmp__fabric-name'); if (a) set(COMP[a.textContent.trim().toLowerCase()]); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-tmp-opt]')) setTimeout(sync, 80);
  });
})();

/* Notify Me (Oct 1 2026): when a size is sold out, Klaviyo hides our button and injects its own red
   one, restyling it each time it re-renders, so shoppers saw the button flip between two looks.
   Klaviyo's button is kept off-screen (CSS) and a navy Notify Me button, styled like Add to Cart,
   sits in its place and opens Klaviyo's back-in-stock form. Re-checked on every change Klaviyo makes
   and every half second as a safety net, because Klaviyo rebuilds its button on variant change. */
(function () {
  function klButton(form) {
    return Array.prototype.filter.call(form.querySelectorAll('button'), function (b) {
      return /kl-private-reset/.test(b.className) && !b.classList.contains('thera-notify-proxy');
    })[0] || null;
  }
  function syncProxy() {
    var form = document.querySelector('form.tmp__form');
    if (!form) return;
    var atc = form.querySelector('[data-tmp-atc]');
    if (!atc) return;
    var kl = klButton(form);
    var px = form.querySelector('.thera-notify-proxy');
    var atcHidden = atc.style.display === 'none' || getComputedStyle(atc).display === 'none';
    var wantProxy = !!kl && atcHidden && atc.classList.contains('tmp__atc--notify');
    if (wantProxy) {
      if (!px) {
        px = document.createElement('button');
        px.type = 'button';
        px.className = 'tmp__atc tmp__atc--notify thera-notify-proxy';
        px.textContent = 'Notify Me';
        px.addEventListener('click', function (e) {
          e.preventDefault();
          var k = klButton(form);
          if (k) k.click();
        });
        atc.parentNode.insertBefore(px, atc);
      }
      if (px.style.display === 'none') px.style.display = '';
    } else if (px && px.style.display !== 'none') {
      px.style.display = 'none';
    }
  }
  var t = null;
  function schedule() { if (!t) t = setTimeout(function () { t = null; syncProxy(); }, 0); }
  function start() {
    var form = document.querySelector('form.tmp__form');
    if (!form) return;
    syncProxy();
    new MutationObserver(schedule).observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    setInterval(syncProxy, 500);
  }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();

/* Desktop thumbnail row (Oct 2 2026): tell the CSS how many thumbnails there are, so more than 6 sit
   on one scrolling line instead of wrapping. Re-runs whenever the gallery is rebuilt for a new colour. */
(function () {
  function sync(g) {
    var n = Math.max(g.querySelectorAll('img').length - 1, 0);
    var prev = g.style.getPropertyValue('--tmp-cols');
    g.style.setProperty('--tmp-cols', String(Math.max(n, 6)));
    g.classList.toggle('is-scroll', n > 6);
    if (prev !== '') g.scrollLeft = 0;
  }
  function init() {
    document.querySelectorAll('[data-tmp-gallery]').forEach(function (g) {
      sync(g);
      if (window.MutationObserver) new MutationObserver(function () { sync(g); }).observe(g, { childList: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Oct 8 2026: desktop gallery fits the screen + prev/next arrows; mobile thumbnail arrows.
   - The large photo is sized to the space left under the compact sticky header, minus the thumbnail
     row, so the whole gallery fits on a laptop screen (--tmp-main-h, read by thera-pdp-fixes.css).
   - Arrows on the large photo step through the colour's photos by clicking the next / previous
     thumbnail (the thumbnail handler above does the swap). They are re-added whenever the gallery is
     rebuilt for a new colour.
   - Mobile: the thumbnail column scrolls; arrows at its top / bottom page through it. */
(function () {
  var ARROW = function (dir) {
    var d = dir < 0 ? 'M19 12H5M11 6l-6 6 6 6' : 'M5 12h14M13 6l6 6-6 6';
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="' + d + '" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  };
  var CHEV = function (up) {
    return '<span><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="' + (up ? 'M6 15l6-6 6 6' : 'M6 9l6 6 6-6') + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
  };
  var desktop = function () { return window.matchMedia('(min-width: 991px)').matches; };

  function imgs(g) { return Array.prototype.slice.call(g.querySelectorAll(':scope > img')); }
  function current(g) { return g.querySelector(':scope > img.is-main') || imgs(g)[0]; }

  function fit(g) {
    if (!desktop()) { g.style.removeProperty('--tmp-main-h'); return; }
    var ann = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--thera-ann-h')) || 0;
    var top = ann + 84;
    var list = imgs(g), main = current(g);
    var thumb = list.filter(function (i) { return i !== main; })[0];
    var thumbH = thumb ? thumb.getBoundingClientRect().height + 10 : 0;
    var h = Math.round(window.innerHeight - top - thumbH - 20);
    h = Math.max(320, Math.min(760, h));
    g.style.setProperty('--tmp-main-h', h + 'px');
  }

  function step(g, dir) {
    var list = imgs(g); if (list.length < 2) return;
    var i = list.indexOf(current(g));
    var target = list[(i + dir + list.length) % list.length];
    target.click();
    // keep the new large photo's old thumbnail neighbourhood in view when the row scrolls sideways
    if (g.classList.contains('is-scroll')) {
      var next = list[(list.indexOf(target) + dir + list.length) % list.length];
      if (next) {
        var gr = g.getBoundingClientRect(), r = next.getBoundingClientRect();
        if (r.right > gr.right) g.scrollLeft += r.right - gr.right + 8;
        else if (r.left < gr.left) g.scrollLeft -= gr.left - r.left + 8;
      }
    }
  }

  function ensureNav(g) {
    var nav = g.querySelector(':scope > .thera-gal-nav');
    if (!nav) {
      nav = document.createElement('div');
      nav.className = 'thera-gal-nav';
      nav.innerHTML = '<button type="button" class="thera-gal-btn" data-dir="-1" aria-label="Previous photo">' + ARROW(-1) + '</button>' +
        '<button type="button" class="thera-gal-btn" data-dir="1" aria-label="Next photo">' + ARROW(1) + '</button>';
      nav.addEventListener('click', function (e) {
        var b = e.target.closest('.thera-gal-btn'); if (!b) return;
        e.preventDefault(); e.stopPropagation();
        step(g, parseInt(b.getAttribute('data-dir'), 10));
      });
      g.appendChild(nav);
    }
    nav.hidden = imgs(g).length < 2;
  }

  function initDesktop(g) {
    var busy = false;
    var refresh = function () {
      if (busy) return; busy = true;
      ensureNav(g); fit(g);
      busy = false;
    };
    refresh();
    new MutationObserver(function (muts) {
      // ignore our own nav insert; react to the colour gallery being rebuilt
      if (muts.some(function (m) { return Array.prototype.some.call(m.addedNodes, function (n) { return n.tagName === 'IMG'; }) || Array.prototype.some.call(m.removedNodes, function (n) { return n.nodeType === 1 && n.classList && n.classList.contains('thera-gal-nav'); }); })) refresh();
    }).observe(g, { childList: true });
    g.addEventListener('load', function () { fit(g); }, true);
    window.addEventListener('resize', function () { fit(g); });
  }

  function initMobile(strip) {
    if (strip.parentNode.classList.contains('thera-mthumbs-wrap')) return;
    var wrap = document.createElement('div');
    wrap.className = 'thera-mthumbs-wrap';
    strip.parentNode.insertBefore(wrap, strip);
    wrap.appendChild(strip);
    var up = document.createElement('button'), down = document.createElement('button');
    up.type = down.type = 'button';
    up.className = 'thera-mthumb-btn thera-mthumb-btn--up'; up.setAttribute('aria-label', 'Previous thumbnails'); up.innerHTML = CHEV(true);
    down.className = 'thera-mthumb-btn thera-mthumb-btn--down'; down.setAttribute('aria-label', 'More thumbnails'); down.innerHTML = CHEV(false);
    wrap.appendChild(up); wrap.appendChild(down);
    var sync = function () {
      var more = strip.scrollHeight - strip.clientHeight > 2;
      up.hidden = !more || strip.scrollTop < 4;
      down.hidden = !more || strip.scrollTop + strip.clientHeight >= strip.scrollHeight - 4;
    };
    var page = function (dir) {
      var t = strip.querySelector('.tmp__mthumb');
      var by = t ? (t.getBoundingClientRect().height + 8) * 2 : 120;
      strip.scrollBy({ top: dir * by, behavior: 'smooth' });
    };
    up.addEventListener('click', function () { page(-1); });
    down.addEventListener('click', function () { page(1); });
    strip.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    strip.addEventListener('load', sync, true);
    new MutationObserver(sync).observe(strip, { childList: true });
    sync();
  }

  function init() {
    document.querySelectorAll('[data-tmp-gallery]').forEach(initDesktop);
    document.querySelectorAll('[data-tmp-mthumbs]').forEach(initMobile);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
